module.exports = __webpack_public_path__ + "static/media/image14.49c90f79.webp";